import { formatCurrency } from "../../../../utils/formatCurrency";
import {
  walkInDraftStepLabel,
  walkInDraftTitle,
} from "../../../../utils/walkInBookingDraft";

const formatSaved = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString();
  } catch {
    return "—";
  }
};

const WalkInDraftsPanel = ({
  drafts = [],
  activeId = "",
  onContinue,
  onDelete,
}) => {
  if (!drafts.length) {
    return (
      <div className="rounded-lg border border-stone-200 bg-stone-50 py-10 text-center text-sm text-stone-500">
        No saved drafts. Use <span className="font-semibold">Save draft</span> on
        a booking, or <span className="font-semibold">Start another</span> to keep
        one and begin the next.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-lg border border-stone-200">
      <table className="w-full min-w-[720px]">
        <thead>
          <tr className="bg-stone-100 text-[11px] font-semibold uppercase tracking-wide text-stone-500 text-left">
            <th className="py-2 px-3">Draft</th>
            <th className="py-2 px-3">Step</th>
            <th className="py-2 px-3">Amount</th>
            <th className="py-2 px-3">Saved</th>
            <th className="py-2 px-3 text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {drafts.map((draft, idx) => {
            const data = draft.data || {};
            const amount = parseFloat(
              data.walkInFinalPrice || draft.totalCost || 0,
            );
            const isActive = draft.id === activeId;
            return (
              <tr
                key={draft.id}
                className={idx % 2 ? "bg-stone-50" : "bg-white"}
              >
                <td className="py-2.5 px-3">
                  <p className="text-sm font-semibold text-stone-900">
                    {walkInDraftTitle(draft)}
                    {isActive ? (
                      <span className="ml-2 text-[10px] font-bold uppercase tracking-wide text-orange-600">
                        Open
                      </span>
                    ) : null}
                  </p>
                  <p className="text-xs text-stone-500 mt-0.5">
                    {[data.senderMobileNumber, data.receiverMobileNumber]
                      .filter(Boolean)
                      .join(" · ") || "No phone yet"}
                  </p>
                </td>
                <td className="py-2.5 px-3 text-sm">
                  {walkInDraftStepLabel(draft)}
                </td>
                <td className="py-2.5 px-3 text-sm font-semibold">
                  {amount > 0 ? formatCurrency(amount, "GBP") : "—"}
                </td>
                <td className="py-2.5 px-3 text-sm whitespace-nowrap">
                  {formatSaved(draft.savedAt)}
                </td>
                <td className="py-2.5 px-3">
                  <div className="flex justify-end gap-2">
                    <button
                      type="button"
                      onClick={() => onContinue(draft.id)}
                      className="h-8 px-3 rounded-lg bg-orange-600 text-white text-xs font-semibold hover:bg-orange-700"
                    >
                      Continue
                    </button>
                    <button
                      type="button"
                      onClick={() => onDelete(draft.id)}
                      className="h-8 px-3 rounded-lg border border-stone-200 bg-white text-xs font-semibold text-stone-700 hover:bg-stone-50"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default WalkInDraftsPanel;
